import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/LuisHernandez_Home/subs.vtt';
import poster from '@/static/assets/reviews/LuisHernandez_Home/video.jpg';

export const LuisHernandez: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Home, ReviewProduct.All],
  reviewerName: 'Luis',
  videoUrl: `${ASSETS_URL}/home/LuisHernandez_Home.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
